const afterOpacity = (
  foreground: number[],
  opacity: number,
  background = [255, 255, 255],
) => foreground.map(
  (section, index) => opacity * section + (1 - opacity) * background[index],
);

export default (color: string, alpha = 0.1): string => {
  const rgb = color.match(/\w\w/g);
  if (rgb) {
    return `rgb(${afterOpacity(rgb.map(x => parseInt(x, 16)), alpha)})`;
  }
  return 'rgb(0,0,0)';
};
